export default __webpack_public_path__ + "static/media/ImportBill.cb304a4c.csv";